import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'components/ui/button';

export default function ShadowsHeader({ onCreate }) {
  return (
    <div className="d-flex justify-content-between align-items-end mb-3">
      <h6>Grids</h6>
      <Button onClick={onCreate}>New Grid</Button>
    </div>
  );
}

ShadowsHeader.propTypes = {
  onCreate: PropTypes.func.isRequired,
};
